import type { SVGProps } from 'react';
const DawnFlagJM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-JM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-JM_svg__a)">
      <path fill="#1DBE4F" d="M0 0h22v16H0z" />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="m0 0 9.429 8L0 16zM22 0l-9.429 8L22 16z"
        clipRule="evenodd"
      />
      <path
        fill="#FFD646"
        fillRule="evenodd"
        d="M9.126 8-2.18 15.765l1.172 1.768L11 9.287l12.007 8.246 1.172-1.769L12.873 8 24.18.235l-1.172-1.768L11 6.713-1.008-1.533-2.18.235z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagJM;
